export default "__VITE_ASSET__AvmCR5bc__"